// app/javascript/controllers/server_clock_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
    connect() {
        // Obtenemos la hora del servidor desde el atributo data
        this.serverTime = new Date(this.element.dataset.initialTime).getTime()
        this.clientTime = Date.now()

        // Calculamos la diferencia (offset) entre el servidor y el cliente
        this.offset = this.serverTime - this.clientTime

        // Actualizamos inmediatamente y luego cada segundo
        this.updateClock()
        this.interval = setInterval(() => this.updateClock(), 1000)
    }

    disconnect() {
        clearInterval(this.interval)
    }

    updateClock() {
        // La hora "actual" del servidor es la hora del cliente + el offset
        const now = new Date(Date.now() + this.offset)

        // Formateamos a HH:MM:SS
        const timeString = now.toLocaleTimeString('es-ES', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        })

        this.element.textContent = timeString
    }
}